import React, {useEffect, useState} from 'react';
import Layout from '../components/Layout';
import {api} from '../api';

const CATEGORIES = ['Travel', 'Meals', 'Office Supplies', 'Software', 'Equipment', 'Training', 'Other'];

export default function Expenses() {
  const [expenses, setExpenses] = useState([]);
  const [showForm, setShowForm] = useState(false);

  const load = () => api('/hcm/my-expenses').then(r => r.ok ? r.json() : []).then(setExpenses).catch(() => {});
  useEffect(load, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const fd = new FormData(e.target);
    await api('/hcm/my-expenses', {method: 'POST', body: fd});
    e.target.reset(); setShowForm(false); load();
  };

  const statusBadge = (s) => {
    const cls = s === 'approved' ? 'bg-green-100 text-green-800' : s === 'denied' ? 'bg-red-100 text-red-800' : 'bg-yellow-100 text-yellow-800';
    return <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${cls}`}>{s}</span>;
  };

  const total = expenses.filter(e => e.status === 'approved').reduce((sum, e) => sum + (e.amount || 0), 0);
  const pending = expenses.filter(e => e.status === 'pending').reduce((sum, e) => sum + (e.amount || 0), 0);

  return (
    <Layout>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-900">Expenses</h2>
        <button onClick={() => setShowForm(true)} className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 text-sm">Submit Expense</button>
      </div>

      <div className="grid grid-cols-2 gap-4 mb-6">
        <div className="bg-white rounded-lg shadow p-4"><p className="text-sm text-gray-500">Approved</p><p className="text-2xl font-bold text-green-600">${total.toLocaleString()}</p></div>
        <div className="bg-white rounded-lg shadow p-4"><p className="text-sm text-gray-500">Pending</p><p className="text-2xl font-bold text-yellow-600">${pending.toLocaleString()}</p></div>
      </div>

      {showForm && (
        <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow p-6 mb-6 space-y-4">
          <h3 className="text-lg font-semibold text-gray-900">New Expense</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div><label className="block text-sm font-medium text-gray-700 mb-1">Description *</label><input name="description" required className="w-full px-3 py-2 border border-gray-300 rounded-lg" /></div>
            <div><label className="block text-sm font-medium text-gray-700 mb-1">Amount *</label><input name="amount" type="number" step="0.01" required className="w-full px-3 py-2 border border-gray-300 rounded-lg" /></div>
            <div><label className="block text-sm font-medium text-gray-700 mb-1">Category</label>
              <select name="category" className="w-full px-3 py-2 border border-gray-300 rounded-lg"><option value="">Select...</option>{CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}</select>
            </div>
            <div><label className="block text-sm font-medium text-gray-700 mb-1">Receipt</label><input name="receipt" type="file" accept="image/*,.pdf" className="text-sm text-gray-600" /></div>
          </div>
          <div className="flex gap-2">
            <button type="submit" className="bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 text-sm">Submit</button>
            <button type="button" onClick={() => setShowForm(false)} className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 text-sm">Cancel</button>
          </div>
        </form>
      )}

      <div className="bg-white rounded-lg shadow divide-y">
        {expenses.map(e => (
          <div key={e.id} className="px-4 py-4 flex items-center justify-between">
            <div>
              <p className="font-medium text-gray-900">{e.description}</p>
              <p className="text-sm text-gray-500">{e.category || 'Uncategorized'} · {e.submittedAt ? new Date(e.submittedAt).toLocaleDateString() : ''}</p>
            </div>
            <div className="flex items-center gap-4">
              <span className="font-semibold text-gray-900">${Number(e.amount).toLocaleString()}</span>
              {statusBadge(e.status)}
            </div>
          </div>
        ))}
        {expenses.length === 0 && <div className="text-center py-8 text-gray-500">No expenses submitted yet.</div>}
      </div>
    </Layout>
  );
}
